// This file was generated by "make codegen/icons". DO NOT EDIT.
import { createSvgIcon } from "@mui/material";
/* GENERATED */
const ExportsIcon = createSvgIcon(
  <svg fill="none" viewBox="0 0 42 42">
    <path
      fill="url(#exports_svga)"
      fillRule="evenodd"
      d="M1.24 0C.55 0 0 .55 0 1.24v39.52C0 41.45.55 42 1.24 42h29.64c.68 0 1.24-.55 1.24-1.24V25.94a1.24 1.24 0 1 0-2.47 0v13.59H2.47V2.47h17.3v8.65c0 .68.55 1.23 1.23 1.23h8.65v3.7a1.24 1.24 0 1 0 2.47 0v-4.93q0-.5-.36-.88L21.87.36A1.2 1.2 0 0 0 21 0zm21 4.22 5.66 5.66h-5.66zm13.57 10.6a1.24 1.24 0 0 0-.86 2.11l2.83 2.83H25.94c-1.67-.02-1.67 2.5 0 2.48h11.84l-2.83 2.83a1.23 1.23 0 1 0 1.75 1.75l4.94-4.95a1.24 1.24 0 0 0 0-1.74l-4.94-4.94a1.2 1.2 0 0 0-.89-.38"
      clipRule="evenodd"
    />
    <defs>
      <linearGradient
        id="exports_svga"
        x1={0}
        x2={43.04}
        y1={0}
        y2={40.91}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#9147FF" />
        <stop offset={1} stopColor="#4C35E8" />
      </linearGradient>
    </defs>
  </svg>,
  "Exports",
);
export default ExportsIcon;
